import React, { useEffect, useState } from "react";
import { MenuItem, Tooltip,IconButton, Menu, Box,} from "@mui/material";
import { Offcanvas } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CiEdit } from "react-icons/ci";
import CommonDeleteDialog from "../../common/CommonDelete";
import { fetchEntityById,} from "../../../apis/apiService";
import { useSelector } from "react-redux";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import { CommonAddIssue } from "../../common/Issue/CommonAddIssue";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { usePersistentFilter } from "../../../assets/hooks/usePersistentFilter";
import { useTheme } from "../../../ThemeContext";
import IssueBoard from "../issues/IssueBoard";



const TaskIssue = ({ setIssueCount }) => {
  const { isDarkMode } = useTheme();
  const [viewMode, setViewMode] = usePersistentFilter("taskIssueDetailViewMode", "list");
  const [showProject, setShowProject] = useState(false);
  const [showIssue, setShowIssue] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const { project_id } = useParams();
  const navigate = useNavigate();
  // console.log("project_id :", project_id);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { role: login_user_role, id: login_user_id } = login_user;

  const { reset } = useForm();

  // Action menu state
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleShowProject = () => setShowProject(true);

  const handleMenuOpen = (event, row) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleEditOpen = () => {
    const row = selectedRow;
    handleMenuClose();
    navigate(
      `/projects/projectDetail/${row.project_id}/issue/IssueDetail/${row.id}`,
      { state: { taskIssueList: showIssue } }
    );
  };



  // ── Columns ────────────────────────────────────────────────────────────────
  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 90,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
          <IconButton
            size="small"
            onClick={(e) => handleMenuOpen(e, params.row)}
            style={{ padding: "10px", marginBottom: "10px" }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </div>
      ),
    },
    { field: "issue_id", headerName: "ID", width: 100 },
    { field: "title", headerName: "Issue Name", width: 200 },
    { field: "reporter", headerName: "Reporter", width: 150 },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 130,
      renderCell: (params) => (
        <span style={{ color: params.row.status_colour }}>
          {params.row.current_status_name}
        </span>
      ),
    },
    { field: "added_at", headerName: "Created Time", width: 180 },
    { field: "assignee", headerName: "Assignee", width: 150 },
    { field: "due_date", headerName: "Due Date", width: 130 },
    {
      field: "priority_name",
      headerName: "Priority",
      width: 120,
      renderCell: (params) => (
        <span style={{ color: params.row.priority_colour }}>
          {params.row.priority_name}
        </span>
      ),
    },
  ];

  // ── Fetch ──────────────────────────────────────────────────────────────────
  const fetchShowIssue = async () => {
    setLoading(true);
    try {
      const response = await fetchEntityById("task/issue/show", id);
      // //console.log()(" show  issue :", response.issues);
      if (response?.data) {
        const dataWithId = response.data.map((project) => ({
          ...project,
          id: project.issue_id,
        }));

        setShowIssue(dataWithId);
        if (setIssueCount) setIssueCount(dataWithId.length);
      } 
      else {
        if (setIssueCount) setIssueCount(0);
      }
    } 
    catch (err) {
      console.error("Error fetching show issue", err);
      if (setIssueCount) setIssueCount(0);
    } 
    finally {
      setLoading(false);
    }
  };
  // const handleApplyIssue = (newRow) => {
  //   setShowIssue((prev) => [...prev, newRow]);
  //   setShowProject(true);
  // };

  // const handleApplyIssue = (newRow) => {
  //   const rowWithId = { ...newRow, id: newRow.issue_id }; // Ensure the new row has an `id` field
  //   setShowIssue((prev) => [...prev, rowWithId]);
  //   setShowProject(true);

  const handleApplyIssue = (newRow) => {
    const newRowWithId = {
      ...newRow,
      id: newRow.issue_id || `temp-id-${Date.now()}`,
    };
    setShowIssue((prev) => [...prev, newRowWithId]);
    // //console.log()("issue row with row ", newRowWithId);
    setShowProject(false);
  };

  useEffect(() => {
    fetchShowIssue();
  }, [id]);

  const navigateIssue = (params) => {
    const row = params.row;
    navigate(
      `/projects/projectDetail/${row.project_id}/issue/IssueDetail/${row.id}`,
      { state: { taskIssueList: showIssue } }
    );
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <>
      {/* Add Issue Offcanvas */}
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {/* <AddSubTaskIssueComponent
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}
            // onCancel={() => setShowFilter(false)}
            fetchShowIssue={fetchShowIssue}
            onApply={handleApplyIssue}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
          /> */}
          <CommonAddIssue
            onClear={() => reset()}
            onCancel={() => setShowProject(false)}
            // Issues={Issues}
            fetchIssues={fetchShowIssue}
            path="task/issue"
            taskId={id}
            project_id={project_id}
            isTaskDetail={true}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      {/* Action Context Menu */}
      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem onClick={handleEditOpen}>
          <CiEdit className="me-2" color="blue" />
          Edit Issue
        </MenuItem>
        {(["ADMIN", "MANAGER"].includes(login_user_role) ||
          selectedRow?.added_by === login_user_id) && (
          <CommonDeleteDialog
            name="Issue"
            refetchList={fetchShowIssue}
            handleListClose={handleMenuClose}
            url="issue/delete"
            id={selectedRow?.id}
            statusName={selectedRow?.title}
            logHours={selectedRow?.log_hours}
          />
        )}
      </Menu>

      {/* Toolbar: View Toggle + Add Button */}
      <Box
        className="d-flex justify-content-between align-items-center"
        sx={{
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          borderRadius: "6px",
          padding: "12px 16px",
          marginBottom: "12px",
          backgroundColor: isDarkMode ? "transparent" : "#fff",
          marginTop: "10px",
        }}
      >

        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <Tooltip title="Table View">
            <IconButton
              onClick={() => setViewMode("list")}
              sx={{
                backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                color: viewMode === "list" ? "rgba(18, 183, 159, 1)" : "#626161",
                border: viewMode === "list" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                borderRadius: "4px",
                height: "32px",
                width: "75px",
                gap: "4px",
                fontSize: "13px",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              
              <CiViewList size={18} />
              Table
            </IconButton>
          </Tooltip>

          <Tooltip title="Board View">
            <IconButton
              onClick={() => setViewMode("board")}
              sx={{
                backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                borderRadius: "4px",
                height: "32px",
                width: "75px",
                gap: "4px",
                fontSize: "13px",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <MdViewQuilt size={18} />
              Board
            </IconButton>
          </Tooltip>
        </div>

        {login_user_role !== "CLIENT" && (
          <button className="add_btn" onClick={handleShowProject}>
            Add Issues
          </button>
        )}
      </Box>

      {/* Content: Table or Board */}
      <div style={{ width: "100%" }}>
        <div style={{ height: showIssue.length === 0 && !loading ? "300px" : "auto" }}>
          <div className="h-auto">
            {loading ? (
              <div className="text-rgba-gray p-3 text-center">Loading...</div>
            ) : viewMode === "list" ? (
              <DataGrid
                rows={showIssue}
                columns={columns}
                pagination
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                getRowId={(row) => row.id || `row-${Date.now()}`}
                slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                pageSizeOptions={[10, 20, 30, 40]}
                onRowClick={(params, event) => {
                  // Only navigate if click wasn't on the action button
                  if (!event.target.closest(".MuiIconButton-root")) {
                    navigateIssue(params);
                  }
                }}
              />
            ) : (
              <IssueBoard
                ProjectID={project_id}
                allIssues={showIssue}
                onRefresh={fetchShowIssue}
                loading={false}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskIssue;
